module.exports = __webpack_public_path__ + "static/media/pos.3867e834.png";